import '../../../../../node_modules/@glidejs/glide/dist/css/glide.core.css'
import '../../../../../node_modules/@glidejs/glide/dist/css/glide.theme.css'
import Glide from '@glidejs/glide'

const days = {
  elContentSlider: '',
  init() {
    this.elContentSlider = $q('.bb-section--home-days .content-slider')

    if (!this.elContentSlider) return

    new Glide(this.elContentSlider.first, {
      type: 'carousel'
    }).mount()

    this.elContentSlider.listen('mousemove', () => document.body.classList.add('js-pointer'))
    this.elContentSlider.listen('mouseleave', () => document.body.classList.remove('js-pointer'))
  }
}

export default days
